<template>
  <div>
    <va-modal
      v-model="show"
      :okToClose="canClose"
      :show.sync="show"
      :noOutsideDismiss="true"
      ref="editUserProfileModal"
      :okText="'users.save' | translate"
      :cancelText="'users.cancel' | translate"
      okClass="btn btn-primary btn-micro"
      cancelClass="btn-cancelar btn btn-primary btn-micro"
      @cancel="cancelUpdateProfile"
      @ok="updateProfile"
      :okDisabled="isSubmitting">

        <div slot="title">
          <form class="form-inline">
            {{ $t('profile.edit')}}
          </form>
        </div>

      <!-- Input User Name -->
      <div class="form-group col-12" :class="{'has-error': (formErrors.has('name')) && form.name != ''}" style="margin-bottom: 1.25rem;">
        <div class="input-group">
          <va-input
            v-model="form.name"
            id="name-input"
            :label="$t('users.inputs.name')"
            required/>
          <small v-show="formErrors.has('name')" class="help text-danger">
            {{'profile.errors.' + formErrors.get('name') | translate}}
          </small>
        </div>
      </div>

      <!-- Input User Name -->
      <div class="form-group col-12" :class="{'has-error': (formErrors.has('nickname')) && form.nickname != ''}" style="margin-bottom: 1.25rem;">
        <div class="input-group">
          <va-input
            v-model="form.nickname"
            id="nickname-input"
            :label="$t('users.inputs.nickname')"
            required/>
          <small v-show="formErrors.has('nickname')" class="help text-danger">
            {{'profile.errors.' + formErrors.get('nickname') | translate}}
          </small>
        </div>
      </div>

      <!-- Input User Language -->
      <div class="form-group address col-12">
        <div class="input-group">
            <label for="country-multiselect">{{'users.inputs.language' | translate}}</label>
            <multiselect
              id="country-multiselect"
              v-model="form.language"
              :allow-empty="false"
              :multiple="false"
              :options="countries"
              track-by="id"
              :custom-label="option => $t(`language.${option.language_key}`)"
              open-direction="bellow"
              select-label=""
              placeholder="---"
              deselect-label="×"
              >

            </multiselect>
        </div>
      </div>
    </va-modal>
  </div>
</template>
<script>
import CountryList from '@/data/CorrectedCountryList'
import Multiselect from 'vue-multiselect'
import Errors from '@/utils/CustomNodeErrors'
export default {
  // props: ['show'],
  components: {
    Multiselect
  },
  data () {
    return {
      show: false,
      form: {
        name: this.$auth.user().name,
        nickname: this.$auth.user().nickname || null,
        language: this.$store.state.languages.find(lang => lang.lang === this.$auth.user().language.toLowerCase())
      },
      canClose: false,
      isSubmitting: false,
      formErrors: new Errors()
    }
  },
  mounted () {
    this.show = true
    // this.$refs.editUserProfileModal.open()
  },
  methods: {
    cancelUpdateProfile: function () {
      setTimeout(() => {
        this.$emit('cancel-update')
      }, 250)
    },
    updateProfile: function (url = `${this.$store.state.evollauth_server}/auth/me`, method = 'PATCH') {
      this.isSubmitting = true
      this.formErrors.clear()
      let data = {
        name: this.form.name.trim(),
        nickname: this.form.nickname ? this.form.nickname.trim() !== '' ? this.form.nickname.trim() : null : null,
        language: this.form.language.lang.toLowerCase()
      }
      if (data.language === 'gb') {
        data.language = 'en'
      }
      this.$http({ url, method, data })
        .then((response) => {
          this.$emit('profile-updated', data)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.formErrors.record(err.response.data.errors)
          }
        }).finally(() => {
          this.isSubmitting = false
        })
    }
  },
  computed: {
    countries: function () {
      return this.$store.state.languages
    },
  }
}
</script>

<style scoped lang="scss">
.control-label {
  z-index: 0 !important;
}

label {
  justify-content: normal;
  font-size: 0.6rem;
  color: #29c4a9;
  font-weight: 600;
  text-transform: uppercase;
  top: -0.6rem;
  left: 0;
  margin-bottom: 0;
}

.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #29c4a9;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  cursor: pointer;
}

.custom__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  border-radius: 5px;
}

.custom__tag-icon:focus, .custom__tag-icon:hover {
  background: #21ab93;
}

.custom__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}

.custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
  color: #fff;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background: #21ab93 !important;
}

.multiselect__clear {
  position: absolute;
  right: 33px;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
  z-index: 1;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 12px;
  background: #C0C0C0;
  top: 15px;
  right: 4px;
}

.multiselect__clear:after {
  transform: rotate(-45deg);
}

.multiselect__clear:before {
    transform: rotate(45deg);
}
</style>
